export default __webpack_public_path__ + "static/media/Filter.0360134f.svg";